import React from 'react';
import logo from './logo.svg';
import './App.css';
import { Link, Route, Routes } from 'react-router-dom';
import VoterFileUpload from './views/voter-file-upload/VoterFileUpload';

function Home() {
  return (
    <div className="App">
      <header className="App-header">
        <h2>VotePA Administration</h2>
        <Link to="/voter-file-upload"> Voter File Upload</Link>
      </header>
    </div>
  );
}

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/voter-file-upload" element={<VoterFileUpload />} />
    </Routes>
  );
}

export default App;
